// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3292":"css/admin-app.6747","5010":"css/app.6747"}[chunkId] + ".css";
};